// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_az-0";
export var optionCard = "_az-1";